import { useConfiguratorContext } from '@augmatica/iframe-interface-react'
import InsideOutsideToggle from '../InsideOutsideToggle/InsideOutsideToggle'
import * as Styled from './styles'
import { useAppSelector } from '../../hooks'

const OverlayControls: React.FC = () => {
  const configurator = useConfiguratorContext()

  const { showAnnotations } = useAppSelector((state) => state.model)

  return (
    <Styled.OverlayControls>
      <Styled.ModelControls>
        <Styled.ToggleAnnotationsButton
          onClick={() => {
            configurator.toggleAnnotations(!showAnnotations)
          }}
        >
          <i className="far fa-ruler" aria-hidden="true" />
        </Styled.ToggleAnnotationsButton>

        <Styled.CameraZoomControls>
          <button
            className="camera-zoom-in"
            onClick={() => {
              configurator.cameraZoomIn()
            }}
          >
            <i className="far fa-search-plus" aria-hidden="true" />
          </button>

          <Styled.ButtonDivider />

          <button
            className="camera-zoom-out"
            onClick={() => {
              configurator.cameraZoomOut()
            }}
          >
            <i className="far fa-search-minus" aria-hidden="true" />
          </button>
        </Styled.CameraZoomControls>

        {(configurator.undo || configurator.redo) && (
          <Styled.HistoryControls>
            <button
              className="undo"
              onClick={() => {
                configurator.undo?.()
              }}
              disabled={!configurator.undo}
            >
              <Styled.UndoIcon className={!configurator.undo && 'disabled'} aria-hidden="true" />
            </button>

            <Styled.ButtonDivider $vertical />

            <button
              className="redo"
              onClick={() => {
                configurator.redo?.()
              }}
              disabled={!configurator.redo}
            >
              <Styled.RedoIcon className={!configurator.redo && 'disabled'} aria-hidden="true" />
            </button>
          </Styled.HistoryControls>
        )}
      </Styled.ModelControls>

      <Styled.InsideOutSideToggleContainer>
        <InsideOutsideToggle />
      </Styled.InsideOutSideToggleContainer>
    </Styled.OverlayControls>
  )
}

export default OverlayControls
